package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun HeaderWideContainer(
    horizontalPadding: Dp,
    topPadding: Dp = 15.dp,
    bottomPadding: Dp = 14.dp,
    content: @Composable RowScope.() -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                color = LocalAppTheme.current.color.surface.normal
            )
            .padding(
                horizontal = LocalAppTheme.current.dimension.spacing.space7
            )
            .padding(
                top = topPadding,
                bottom = bottomPadding,
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(horizontalPadding)
    ) {
        content()
    }
}
